var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpayFees(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.748,
    height: 68.142,
    viewBox: "0 0 75.748 68.142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "spay-fees",
    transform: "translate(-1036.943 -1385.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2749",
    "data-name": "Path 2749",
    d: "M-9117.576,1271.5l8.373,68.142,59.8-3.588,7.575-59.8Z",
    transform: "translate(10154.52 114.358)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356",
    transform: "translate(1056.337 1402.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2748",
    "data-name": "Path 2748",
    d: "M186.81,151.051a2.612,2.612,0,0,0-3.694,0L151.765,182.4a2.612,2.612,0,0,0,3.694,3.694l31.351-31.351A2.611,2.611,0,0,0,186.81,151.051Zm-27.973,14.91A7.838,7.838,0,1,0,151,158.124,7.846,7.846,0,0,0,158.838,165.961Zm20.9,5.225a7.838,7.838,0,1,0,7.838,7.838A7.846,7.846,0,0,0,179.738,171.186Z",
    transform: "translate(-151 -150.286)",
    fill: "#ffebf0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpayFees);
export default __webpack_public_path__ + "static/media/spay-fees.4b1d29136febb7202a130fdbd42b474a.svg";
export { ForwardRef as ReactComponent };